import { render } from "./select-channel.vue?vue&type=template&id=1cd69141&lang=pug"
import script from "./select-channel.vue?vue&type=script&setup=true&lang=js"
export * from "./select-channel.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__